<template>
  <div class="premium-overlay-holder" @click="$emit('close')">
    <div class="mdl-card mdl-shadow--2dp">
      <div class="mdl-card__title mdl-card-colo">
        <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>
        <div class="close-button" @click="$emit('close')">
          <i class="material-icons">
            clear
          </i>
        </div>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <p>{{ i18n().text }}</p>

      </div>
    </div>
  </div>
</template>

<script>
  import i18n from "i18n"

  export default {
    name: "PremiumOverlay",
    methods: {
      i18n() { return i18n().premium.overlay }
    }
  }
</script>

<style scoped>
  .premium-overlay-holder {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mdl-card {
    width: 320px;
    margin: auto;
  }
  .mdl-card__title {
    height: 110px;
    color: #fff;
    background: /*url(../../../static/images/voleadstools2_mid.png) 215px 5px no-repeat*/ #241d7f;
    background-size: 100px;
  }

  button {
    background: #1d0585;
    color: white;
    font-weight: 300;
    float: right;
  }

  button:hover {
    background: #2906bf;
    color: white;
    font-weight: 300;
  }

  .mdl-card__supporting-text {
    position: relative;
  }

  .close-button {
    color: white;
    position: absolute;
    right: 3px;
    top: 3px;
    cursor: pointer;
  }
  .close-button:hover {
    transform: scale(1.2);
  }
</style>



// WEBPACK FOOTER //
// PremiumOverlay.vue?29ab456a